
// Register Global components
import Vue from 'vue';
import DeleteConfirm from './delete-confirm.vue';

import EquipmentTagEdit from './equipment-tag-edit.vue';
import EquipmentStatusEdit from './equipment-status-edit.vue';
import EquipmentOptionEdit from './equipment-option-edit.vue';
import EquipmentContactEdit from './equipment-contact-edit.vue';
import EquipmentBannerEdit from './equipment-banner-edit.vue';
import EquipmentCategoriesEdit from './equipment-categories-edit.vue';
import EquipmentExpensesEdit from './equipment-expenses-edit.vue';
import EquipmentExpensesReport from './equipment-expenses-report.vue';
import EquipmentReceivedChecklist from './equipment-received-checklist.vue';
import EquipmentSalesReadyChecklist from './equipment-sales-ready-checklist.vue';
import EquipmentWorkToDo from './equipment-work-to-do.vue';
import EquipmentImagesEdit from './equipment-images-edit.vue';
import EquipmentVideosEdit from './equipment-videos-edit.vue';
import FormatAddress from './format-address.vue';
import FormatPhone from './format-phone.vue';
import FormatEmail from './format-email.vue';
import DisplayContact from './display-contact.vue';

export const setupGlobalComponents = () => {

    // register it globally
    Vue.component('delete-confirm', DeleteConfirm);
    Vue.component('equipment-tag-edit', EquipmentTagEdit);
    Vue.component('equipment-status-edit', EquipmentStatusEdit);
    Vue.component('equipment-option-edit', EquipmentOptionEdit);
    Vue.component('equipment-contact-edit', EquipmentContactEdit);
    Vue.component('equipment-banner-edit', EquipmentBannerEdit);
    Vue.component('equipment-categories-edit', EquipmentCategoriesEdit);
    Vue.component('equipment-expenses-edit', EquipmentExpensesEdit);
    Vue.component('equipment-expenses-report', EquipmentExpensesReport);
    Vue.component('equipment-received-checklist', EquipmentReceivedChecklist);
    Vue.component('equipment-sales-ready-checklist', EquipmentSalesReadyChecklist);
    Vue.component('equipment-work-to-do', EquipmentWorkToDo);
    Vue.component('equipment-images-edit', EquipmentImagesEdit);
    Vue.component('equipment-videos-edit', EquipmentVideosEdit);
    Vue.component('format-address', FormatAddress);
    Vue.component('format-phone', FormatPhone);
    Vue.component('format-email', FormatEmail);
    Vue.component('display-contact', DisplayContact);
}
